module.exports = __webpack_public_path__ + "static/assets/99dc270723d233e29add82eebacc8b57.svg";